import Image from "components/atoms/Image";
import Link from "next/link";
import { useRouter } from "next/router";
import useTranslation from "next-translate/useTranslation";
import React, { VFC, memo } from "react";
import { pagesPath, staticPath } from "faqSrc/lib/$path";

interface Props {
  asPath?: string;
  languageAlts?: string[];
}

const LocaleFlags: VFC<Props> = ({ languageAlts, asPath }) => {
  const router = useRouter();
  const { lang } = useTranslation();
  // router.asPath doesn't work properly in ISR
  const path = asPath ?? router.asPath;

  return (
    <>
      {lang !== "vn" && (
        <Link
          href={
            languageAlts?.length === 0 || languageAlts?.indexOf("vn") !== -1
              ? path
              : pagesPath.$url()
          }
          locale="vn"
          passHref
        >
          <a>
            <Image
              alt="vn"
              src={staticPath.img.flags.vn_svg}
              height={24}
              width={32}
              layout="fixed"
              ampLayout="fixed"
            />
          </a>
        </Link>
      )}
      {lang !== "ja" && (
        <Link
          href={
            languageAlts?.length === 0 || languageAlts?.indexOf("ja") !== -1
              ? path
              : pagesPath.$url()
          }
          locale="ja"
          passHref
        >
          <a>
            <Image
              alt="ja"
              src={staticPath.img.flags.jp_svg}
              height={24}
              width={32}
              layout="fixed"
              ampLayout="fixed"
            />
          </a>
        </Link>
      )}
      {lang !== "en" && (
        <Link
          href={
            languageAlts?.length === 0 || languageAlts?.indexOf("en") !== -1
              ? path
              : pagesPath.$url()
          }
          locale="en"
          passHref
        >
          <a>
            <Image
              alt="en"
              src={staticPath.img.flags.us_svg}
              height={24}
              width={32}
              layout="fixed"
              ampLayout="fixed"
            />
          </a>
        </Link>
      )}
    </>
  );
};

export default memo(LocaleFlags);
